import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { COLUMN_ORDER_EXECUTED_AMOUNT, COLUMN_ORDER_AMOUNT } from "../../index";

export class RenderFillPercentCell {
  public static wrap(columnName: string, rowData) {
    // OMS--17646 always Dealt to avoid >100%  in base

    let dealtFillAmt = rowData[`as_sort_${COLUMN_ORDER_EXECUTED_AMOUNT}`];
    let dealtOpenAmt = rowData[`as_sort_${COLUMN_ORDER_AMOUNT}`];

    if (!dealtFillAmt || !dealtOpenAmt || dealtFillAmt === "-" || dealtOpenAmt === "-") {
      return "-";
    }

    let n = new CubiqTS.BigNumber(dealtFillAmt);
    let d = new CubiqTS.BigNumber(dealtOpenAmt);

    let value = (Number(n.dividedBy(d)) * 100).toPrecision();

    // These tags must not include breaks or padding as a regexp is used to remove tags for csv
    return `<div class="div-percent-outer-div"><div class="div-percent-bar" style="width: ${value}%; background-color: rgba(0,0,0,0.2);"></div><div class="div-percent-value">${rowData[columnName]}</div></div>`;
  }
}
